import axios from "axios";
import { useState } from "react";
import { REACT_APP_BOOT_URL } from "./config";
import { errorGenerator } from "./errorGenerator";
import { useQuery } from "react-query";
import { generatoreCode } from "./generateCode";

export const useBoot = () => {
  const [boot, setBoot] = useState(null);

  const url = REACT_APP_BOOT_URL;

  const queryInfo = useQuery("boot", () => axios.get(url), {
    enabled: true,
    refetchOnWindowFocus: false,
    onSuccess: ({ data }) => {
      // rimuove (se presente) appLink precedente:
      // necessario per assicurarsi che l'applicazione non rimanga fissa su quella schermata
      // * fatto qua perche eseguito di sicuro 1 volta sola per refresh
      window.localStorage.removeItem("RQX_ACTIVE_APPLINK");
      console.log("useBoot data", data);
      setBoot(data);
    },
    onError: ({ error }) => {
      const errorCode = generatoreCode(8).toString();
      errorGenerator(
        errorCode,
        error,
        "useBoot failure",
        "Chiamata GET API fallita per prendere useBoot",
      );
      console.log("useBoot failure", error);
    },
  });

  return { boot, queryInfo };
};
